import React from "react";
import PropTypes from "prop-types";
import "./Layout.css";
import LoadingIcon from "./LoadingIcon";


function LoadingPage({
    message = "Loading..."
}) {

    return (

        <div className="loading-page">

            <div className="loading-status">
                <LoadingIcon />
                <div className="loading-message">
                    <span className="loading-message-text">{message}</span> 
                </div>
            </div>
            <div className="loading-footer">
                <img className="loading-footer-logo" src="/resources/images/logo.png" alt="JustGoRide" />
            </div>
        </div>
    );
};

LoadingPage.propTypes =
{
    message: PropTypes.string
}

export default LoadingPage; 


// WEBPACK FOOTER //
// ./src/components/common/LoadingPage.js